import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWindows as fabFaWindows,
  faApple as fabFaApple,
  faLinux as fabFaLinux,
} from '@fortawesome/free-brands-svg-icons';


import ProductCover from 'Components/Utility/ProductCover';
import Drm from 'Components/Utility/Drm';
import { getFileData } from 'Components/PickAndMix/PickAndMixHelper';
import DlcBadge from 'Components/Cards/DlcBadge';
import SpecialFormattedNumber from 'Components/Utility/Price/SpecialFormattedNumber';
import { currencyCode } from 'Helpers/Geo/data';
import PickAndMixSteamDeckIcons from 'Components/PickAndMix/Cards/PickAndMixSteamDeckIcons';
import PickAndMixCriticScore from 'Components/PickAndMix/Cards/PickAndMixCriticScore';
import PickAndMixStars from 'Components/PickAndMix/Cards/PickAndMixStars';

import 'Components/PickAndMix/Cards/PickAndMixListCard.scss';

const PickAndMixListCard = ({ hit, preSelectedType, forceLightTheme }) => {
  const siteTheme = useSelector(state => state?.siteTheme);
  if (!hit) return null;

  const {
    cover,
    name,
    type,
    displayType,
    coverType,
    drm,
    downloads,
    operating_systems: OS,
    fullPrice,
    steam_deck_support: steamDeckSupport,
    metacritic_score: metaCriticScore,
    opencritic_score: openCriticScore,
    rating_score: ratingScore,
  } = hit;
  const { downloadTypes } = getFileData(downloads);
  const validDrm = Array.isArray(drm) && drm.length > 0 ? drm[0] : null;

  return (
    <div className={`PickAndMixListCard ${forceLightTheme ? 'PickAndMixListCard--light' : ''}`}>
      <div className="PickAndMixListCard__cover">
        <ProductCover
          cover={cover}
          alt={hit.cover_alt_text || `Product cover for ${name}`}
          displayType={displayType}
          coverType={coverType}
        />
      </div>

      <div className="PickAndMixListCard__contentWrapper">
        <div className="PickAndMixListCard__content">
          <div className="PickAndMixListCard__nameIcons">
            <div className="PickAndMixListCard__name">{name}</div>
            <div className="PickAndMixListCard__icons">
              <div className="PickAndMixListCard__icons__drm">
                {validDrm && <Drm drmType={validDrm} colorOverride={forceLightTheme ? 'dark' : ''} />}

                {(type === 'dlc' || displayType === 'dlc') && <DlcBadge />}
              </div>

              {Array.isArray(downloadTypes) && downloads.length > 0 && (
                <div className="PickAndMixListCard__downloads">
                  {downloadTypes.sort().map(file => (
                    <div key={file} className="PickAndMixListCard__downloads__file">
                      {file}
                    </div>
                  ))}
                </div>
              )}

              {Array.isArray(OS) && OS.length > 0 && (
                <div className="PickAndMixListCard__platforms">
                  <React.Fragment>
                    {OS.includes('windows') && (
                      <FontAwesomeIcon icon={fabFaWindows} />
                    )}
                    {OS.includes('mac') && (
                      <FontAwesomeIcon icon={fabFaApple} />
                    )}
                    {OS.includes('linux') && (
                      <FontAwesomeIcon icon={fabFaLinux} />
                    )}
                  </React.Fragment>
                </div>
              )}

              {preSelectedType === 'steamDeckVerified' &&
                <PickAndMixSteamDeckIcons
                  steamDeckSupport={steamDeckSupport}
                  siteTheme={forceLightTheme ? 'light' : siteTheme}

                />
              }
              {preSelectedType === 'criticallyAcclaimed' &&
                <PickAndMixCriticScore
                  opencriticScore={openCriticScore}
                  metaCriticScore={metaCriticScore}
                />
              }

              {preSelectedType === 'fanFavourites' &&
                <PickAndMixStars ratingScore={ratingScore} />
              }
            </div>
          </div>

          <div className="PickAndMixListCard__price">
            <span className="PickAndMixListCard__price__rrp mr-1">RRP</span>
            <SpecialFormattedNumber
              value={fullPrice[`${currencyCode}`]}
              style="currency"
            />
          </div>
        </div>

      </div>
    </div>
  );
};

PickAndMixListCard.propTypes = {
  hit: PropTypes.shape({}),
  preSelectedType: PropTypes.string,
  forceLightTheme: PropTypes.bool,
};

PickAndMixListCard.defaultProps = {
  hit: null,
  preSelectedType: '',
  forceLightTheme: false,
};

export default PickAndMixListCard;
